import PageLoader from './page-loader.component';

export default PageLoader;
